import TrackedModel from "../../tracked/trackedModel";
import {ISortableMainAction} from "../../../interfaces/contentManagementInterfaces";
import Guid from "../../../helpers/guid";
import IRepo from "../../../interfaces/repo";
import Provider from "../../../providers/new/provider";
import Model from "../../model";
import ElementHandler from "../../../services/elementHandler";
import {ISelectedProperty} from "../../../state/modules/singleSelectedProperty";
import Repo from "../../../state/modules/repo";
import Selected from "../../../../formability/listViewBuilder/store/modules/selected";
import ListView from "../listView";
import IProvider from "../../../interfaces/provider";
import MainActionable from "~/models/contentManagement/mainActionable";

export default class ListViewMainAction extends MainActionable(TrackedModel) implements ISortableMainAction {
  _classKey = "mainAction";
  rootModel: ListView;
  sort_order: number;
  action_client_id: string;
  refresh_page_on_completion?: boolean;

  except = ['organization', 'saveTimer', '_organization'];

  constructor() {
    super();
    this.defineProperty('client_id', Guid.create());
    this.defineProperty('refresh_page_on_completion', false);
  }

  _mainActionHandler: ElementHandler = new ElementHandler(this, ListViewMainAction, 'main_actions');

  static repo: IRepo<ListViewMainAction> = new Repo<ListViewMainAction>('listViewMainActions', ListViewMainAction, {}, new Provider(ListViewMainAction, 'main_action', 'main_actions'));
  repo: IRepo<this, IProvider<this>>;

  static get provider(): IProvider<Model> {
    return this.repo.provider;
  }

  get provider(): this['repo']['provider'] {
    return this.repo.provider;
  }

  get elementHandler(): ElementHandler {
    return this.mainActionHandler;
  }

  initialize(root: ListView, parent = root, type, json= {}) {
    this.rootModel = root;
    this.parent = parent;
    this.defineProperty('action_client_id', '');
    this.defineProperty('sort_order', 0);
    this.loadFromJson(json);
    return this;
  }

  static get rootName(): string {
    return 'main_actions';
  }

  get rootName(): string {
    return ListViewMainAction.rootName;
  }

  addToRepo(): void {
    ListViewMainAction.repo.add(this);
  }

  get listView(): ListView {
    return this.rootModel;
  }

  get actionName(): string {
    const objectModel = this.listView.published_object_model || this.listView.object_model;
    const action = objectModel.findObjectModelAction(this.action_client_id);
    return action.label_title;
  }

  get selector(): ISelectedProperty {
    return Selected.listViewMainAction;
  }

  select(): void {
    this.selector.set(this);
  }

  deselect(): void {
    this.selector.deselectIf(this);
  }

  get isSelected(): boolean {
    return this.selector.is(this);
  }

  afterDestroy() {
    super.afterDestroy();
    this.parent.mainActionHandler.recalculateElementPositions();
  }

  get isLast(): boolean {
    return this.sort_order === this.parent.mainActionHandler.lastSortOrder();
  }

  get isFirst(): boolean {
    return this.sort_order <= 0;
  }

  moveUp(): void {
    if (this.isFirst) return;
    this.sort_order--;
    this.parent.mainActionHandler.updateElementPositions(this.parent, this, this.sort_order);
  }

  moveDown(): void {
    if (this.isLast) return;
    this.sort_order++;
    this.parent.mainActionHandler.updateElementPositions(this.parent, this, this.sort_order);
  }
}

